import * as React from 'react';
import { Card, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material';
import { CasinoOutlined, DomainOutlined } from '@mui/icons-material';
import { Grid2 as Grid } from '@mui/material';

interface Props {
    readonly styled: StyledProps;
    readonly title: Entities.UserTitleData;
    readonly onClick: (title: Entities.UserTitleData) => any;
}

export class TitleCard extends React.PureComponent<Props> {
    render() {
        const { styled, title } = this.props;
        const { id, name, imageUrl, organization } = title;

        return (
            <Card key={`title_${id}`}>
                <CardActionArea onClick={this.onCardClick} style={{ height: 126 }}>
                    <CardContent>
                        <Grid container={true} alignItems="center" spacing={2}>
                            <Grid size={12} style={{ display: 'grid', gridColumnGap: 10, gridAutoFlow: 'column', justifyContent: 'flex-start'}}>
                                {!imageUrl && (
                                    <CasinoOutlined style={{width: 50, height: 50, borderRadius: 5, color: styled.themeMode === 'light' ? '#1a1a1a' : '#ececec'}}/>
                                )}
                                {imageUrl && (
                                    <CardMedia image={imageUrl} style={{width: 50, height: 50, borderRadius: 5}}/>
                                )}
                                <Grid container={true} alignItems="center" spacing={0}>
                                    <Grid size={12} style={{ display: 'grid', textAlign: 'left' }}>
                                        <Typography variant="h5" style={{ color: styled.themeMode === 'light' ? '#1a1a1a' : '#ececec', fontSize: '16px', fontWeight: 500 }}>
                                            {name}
                                        </Typography>
                                        <Typography variant="subtitle1" style={{ fontSize: '14px', color: styled.themeMode === 'light' ? '#737373' : '#aeaeae' }}>
                                            {id}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                                <DomainOutlined style={{width: 20, height: 20, borderRadius: 5, color: 'grey'}} />
                                <Typography variant="subtitle2" style={{ color: styled.themeMode === 'light' ? '#737373' : '#aeaeae', fontSize: 12, marginLeft: 2, lineHeight: '15px' }}>
                                    {organization}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    }

    private onCardClick = () => {
        const { title, onClick } = this.props;
        onClick(title);
    };
}
